<template>
    <b-button :class="{ 'btn-label': icon }" :disabled="loading" v-bind="{ ...$attrs, ...$props }" v-on="$listeners">
        <span><slot /></span>
        <i v-if="icon" :class="`bx ${icon} label-icon font-size-18`"></i>
        <i v-if="loading" class="bx bx-loader bx-spin font-size-16 align-middle ml-2"></i>
    </b-button>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String
            },
            variant: {
                type: String,
                default: "primary"
            },
            loading: {
                type: Boolean
            }
        }
    };
</script>

<style></style>
